export default {"src":"/_next/static/media/placeholder.c461243b.svg","height":1080,"width":1920,"blurWidth":0,"blurHeight":0};